<div class="modal-container">
    <h2 mat-dialog-title>Email All Shipping Labels</h2>

    <mat-dialog-content>
        <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">

            <!-- Shipping Label Type dropdown -->
            <mat-form-field fxLayout="column" fxLayoutAlign="stretch">
                <mat-label>{{'emailShippingLabelView.shippingLabelLabel' | translate}}</mat-label>
                <mat-select [formControlName]="'selectedShippingLabel'">
                    <mat-option *ngIf="!shippingLabels?.length" [value]="null" disabled>
                        {{'emailShippingLabelView.noShippingLabelsAvailableText' | translate}}
                    </mat-option>
                    <mat-option *ngFor="let sl of shippingLabels" [value]="sl?.procedureId">{{sl.description}}</mat-option>
                </mat-select>
                <mat-error>{{'emailShippingLabelView.shippingLabelRequiredText' | translate}}</mat-error>
            </mat-form-field>

            <!-- Subject field -->
            <mat-form-field fxLayout="column" fxLayoutAlign="stretch">
                <mat-label>Subject</mat-label>
                <input matInput [formControlName]="'subject'">
                <mat-error>Subject is required</mat-error>
            </mat-form-field>

            <!-- Message field -->
            <mat-form-field fxLayout="column" fxLayoutAlign="stretch">
                <mat-label>Message</mat-label>
                <textarea matInput [formControlName]="'message'" mat-autosize></textarea>
                <mat-error>Message is required</mat-error>
            </mat-form-field>

            <!-- Checkbox 1: Email to route stops / orders -->
            <mat-checkbox [formControlName]="'emailToStops'" color="primary">
                {{checkbox1Text}}
            </mat-checkbox>

            <!-- Checkbox 2: Email to specified addresses -->
            <mat-checkbox [formControlName]="'emailToSpecified'" color="primary">
                {{checkbox2Text}}
            </mat-checkbox>

            <!-- Email input - always visible, enabled/disabled based on checkbox 2 -->
            <app-email-input-with-chips
                #emailInput
                [parentForm]="form"
                [placeholder]="'Email addresses'">
            </app-email-input-with-chips>

        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="close()">Cancel</button>
        <button mat-raised-button
                color="primary"
                (click)="send()"
                [disabled]="!isFormValid()">
            Send
        </button>
    </mat-dialog-actions>
</div>